import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FaUser, FaBook, FaPenAlt, FaQuoteLeft } from "react-icons/fa";
import { motion } from "framer-motion";
import ApiService from "../../models/ApiService";

const DashboardCard = () => {
    const navigate = useNavigate();

    const [data, setData] = useState({
        totalStudent: 0,
        totalLesson: 0,
        totalShayar: 0,
        totalShayari: 0,
    });

    useEffect(() => {
        fetchDashboard();
    }, []);
    const fetchDashboard = async () => {
        try {
            const res = await ApiService.Dashboard();
            if (res.data?.success) {
                setData(res.data.responseContent);
            } else {
                console.error("Failed to load dashboard data");
            }
        } catch (error) {
            console.error("API error:", error);
        }
    };

    const cards = [
        {
            title: "Total Users",
            icon: <FaUser className="text-3xl" />,
            color: "bg-[--secondary-color]",
            path: "/students",
            total: data.totalStudent,
            description: "Registered Users",
        },
        {
            title: "Total Lessons",
            icon: <FaBook className="text-3xl" />,
            color: "bg-[--secondary-color]",
            path: "/lessons",
            total: data.totalLesson,
            description: "Learning materials",
        },
        {
            title: "Total Shaa'ir",
            icon: <FaPenAlt className="text-3xl" />,
            color: "bg-[--secondary-color]",
            path: "/shayars",
            total: data.totalShayar,
            description: "Poets in collection",
        },
        {
            title: "Total Shaa'irii",
            icon: <FaQuoteLeft className="text-3xl" />,
            color: "bg-[--secondary-color]",
            path: "/shayari",
            total: data.totalShayari,
            description: "Poetic verses",
        },
    ];

    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6" id="primary-fonts">
            {cards.map((card, index) => (
                <motion.div
                    key={index}
                    onClick={() => card.path && navigate(card.path)}
                    className={`bg-[--primary-color] p-6 rounded-xl shadow-md flex flex-col cursor-pointer border border-gray-100 transition-all duration-300`}
                    whileHover={{ y: -5, boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)" }}
                    whileTap={{ scale: 0.98 }}
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.3, delay: index * 0.1 }}
                >
                    <div className="flex justify-between items-start w-full mb-4">
                        <div>
                            <p className="text-sm font-medium text-white">{card.title}</p>
                            <h3 className="text-2xl font-bold text-white mt-1">{card.total}</h3>
                            <p className="text-xs text-white mt-1">{card.description}</p>
                        </div>
                        <div className={`w-12 h-12 ${card.color} rounded-lg flex items-center justify-center text-white`}>
                            {card.icon}
                        </div>
                    </div>
                </motion.div>
            ))}
        </div>
    );
};

export default DashboardCard;
